export default "__VITE_ASSET__CCU9tgl6__"